// ─── DEVELOPMENT (ng serve) ───────────────────────────────────────────────
// Requests to /api are proxied via proxy.conf.json to apiUrlDirect below.
//
// ⚠️  DO NOT use this for Android builds!
//     Android builds MUST use: ng build --configuration production
//     Plain `ng build` uses this file → apiUrl='/api' breaks on device.
export const environment = {
  production: false,
  isPlayStoreBuild: false,
  apiUrl: '/api',                                               // proxied — do not change
  apiUrlDirect: 'https://dev-api.milkomatic.com',              // dev backend
  imageBase: 'https://test-media.milkomatic.co.in/',
  masterLock: '57af82018f1a3ce59557255d9671f9d9',
  masterKey: 'bec443023151df62bcd05aa2708ec005',

  firebase: {
    apiKey: 'AIzaSyB8u4cvDKAHE0PtkD_kmL0fKukVmgW-UaQ',
    projectId: 'milkomatic-app-df51e',
    messagingSenderId: '763391508365',
    appId: '1:763391508365:web:a37d33c7feda6f7fde47c4',
    vapidKey: 'BNBQPEoKHLjFjN7BLiKaXLtcP85YRIuB4xp7bB0E6IdgmxaJh-Ngso5fdfrWppkU4lQyJoljViiLV4Bv6GebRic'
  }
};
